module.exports = __webpack_public_path__ + "static/img/feature-1.4cb1693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mss/feature-1.png
// module id = qJu2
// module chunks = 1